import React, { useEffect } from 'react';
import Topbar from '../components/Header/Topbar';
import Navbar from '../components/Header/Navbar';
import Spinner from '../components/Spinner/Spinner';
import Footer from '../components/Footer/Footer';
import BackToTop from '../components/BackToTop/BackToTop';
import SEO from '../components/SEO/SEO';
import $ from 'jquery';

  const pageHeaderStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('/assets/solar-banaer.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    minHeight: '400px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

const Video = () => {
  useEffect(() => {
    // Initialize WOW.js
    if (window.WOW) {
      new window.WOW().init();
    }

    // Hide spinner
    setTimeout(() => {
      const spinner = document.getElementById('spinner');
      if (spinner) {
        spinner.classList.remove('show');
      }
    }, 500);

    // Back to top functionality
    $(window).scroll(function () {
      if ($(this).scrollTop() > 300) {
        $('.back-to-top').fadeIn('slow');
      } else {
        $('.back-to-top').fadeOut('slow');
      }
    });

    $('.back-to-top').click(function (e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 1500, 'easeInOutExpo');
      return false;
    });

    return () => {
      $(window).off('scroll');
      $('.back-to-top').off('click');
    };
  }, []);

  return (
    <>
      <SEO 
        title="Videos"
        description="Watch videos about Galaxy Power System's products and services. Learn more about our battery and solar power solutions."
        keywords="galaxy power videos, solar panel videos, battery maintenance tips"
        canonicalUrl="https://galaxypowersystems.com/video"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Video', url: '/video' }
        ]}
      />
      <Spinner />
      <Topbar />
      <Navbar />
      
      {/* Page Header */}
      <div className="container-fluid page-header py-5 mb-5" style={pageHeaderStyle}>
        <div className="container py-5">
          <h1 className="display-3 text-white mb-3 animated slideInDown">Video</h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="/" className="text-white">Home</a></li>
              <li className="breadcrumb-item text-white active" aria-current="page">Video</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Video Content */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 wow fadeInUp" data-wow-delay="0.1s">
              <div className="ratio ratio-16x9">
                {/* <iframe width="560" height="315" src="https://www.youtube.com/embed/2EPqn-k9Pjk?si=6KEsY2ieVMyJLSMS&amp;start=10" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */}
                <video src="/assets/SOLAR-VIDEO.mp4" controls className="img-fluid rounded w-100" ></video>
              </div>
              <div className="mt-4">
                <h3 className="mb-3">Galaxy Power System - Powering Your World</h3>
                <p>
                  Watch our latest video to learn more about our products and services. 
                  We provide the best power solutions for your home and business needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      
       {/* Use the React BackToTop component */}
      <BackToTop />
    </>
  );
};

export default Video;